'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setOpenSidebar = exports.setDockedSidebar = undefined;
exports.navigateTo = navigateTo;
exports.navigateBack = navigateBack;
exports.navigateReplacing = navigateReplacing;

var _reactRouterRedux = require('program/frontend/components/react-router-redux');

var _reduxActions = require('redux-actions');

function navigateTo(url) {

  if (!url) throw new Error("Invalid URL");

  return function (dispatch) {
    dispatch((0, _reactRouterRedux.push)(url));
  };
}

function navigateBack() {

  return function (dispatch) {
    dispatch((0, _reactRouterRedux.goBack)());
  };
}

function navigateReplacing(url) {

  if (!url) throw new Error("Invalid URL");

  return function (dispatch) {
    dispatch((0, _reactRouterRedux.replace)(url));
  };
}

var setDockedSidebar = exports.setDockedSidebar = (0, _reduxActions.createAction)('SET_DOCKED_SIDEBAR', function (dockedSidebar) {
  return { dockedSidebar: dockedSidebar };
});

var setOpenSidebar = exports.setOpenSidebar = (0, _reduxActions.createAction)('SET_OPEN_SIDEBAR', function (openSidebar) {
  return { openSidebar: openSidebar };
});


//////////////////
// WEBPACK FOOTER
// ./program/frontend/actions/navigation.js
// module id = 870
// module chunks = 0